import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

export const useIsProjectionDone = (riskLevel?: RiskLevel, calculatedRisk?: RiskLevel) => {
  // We compare risklevel with LOW because the backend returns LOW when the risk level is UNSPECIFIED
  // This may only cause a short discrepancy when the risk level is just being calculated and the user set the risk level to LOW
  return calculatedRisk !== RiskLevel.UNSPECIFIED || riskLevel !== RiskLevel.LOW
}
